var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useOffice } from '../../hooks/useOffice';
var OfficeFilter = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, label = _a.label;
    var officeListItems = useOffice().officeListItems;
    var _b = React.useState([]), offices = _b[0], setOffices = _b[1];
    React.useEffect(function () {
        setOffices(columnDef.defaultFilter || []);
    }, [columnDef.defaultFilter]);
    var handleChange = React.useCallback(function (event) {
        var value = event.target.value;
        setOffices(value);
        onFilterChanged(columnDef.tableData.id, value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement.apply(React, __spreadArray([Select, { fullWidth: true, multiple: true, margin: "none", variant: "standard", value: offices, onChange: handleChange, label: label || '' }], officeListItems.map(function (_a) {
        var text = _a.text, value = _a.value;
        return (React.createElement(MenuItem, { key: value, value: value }, text));
    }), false)));
};
export default OfficeFilter;
